import { popoverAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';
import { cssVar } from '@chakra-ui/theme-tools';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  popoverAnatomy.keys,
);

const $arrowBg = cssVar('popper-arrow-bg');
const $arrowShadowColor = cssVar('popper-arrow-shadow-color');

const baseStyle = definePartsStyle({
  content: {
    bg: 'bg.elevated',
    color: 'text.primary',
    borderWidth: '1px',
    borderColor: 'border.muted',
    boxShadow: 'elevation.2',
    _focusVisible: {
      boxShadow: '0 0 0 2px var(--chakra-colors-accent-default)',
    },
    [$arrowBg.variable]: 'var(--chakra-colors-bg-elevated)',
    [$arrowShadowColor.variable]: 'var(--chakra-colors-border-muted)',
  },
  header: {
    color: 'text.primary',
  },
  body: {
    color: 'text.muted',
  },
  footer: {
    bg: 'bg.elevated',
  },
  arrow: {},
});

export const Popover = defineMultiStyleConfig({
  baseStyle,
});
